import { Curve, Point, Wrapper } from './arrowStyle';

const ArrowView = () => {
  return (
    <Wrapper>
      <Curve />
      <Point />
    </Wrapper>
  );
};

export default ArrowView;
